<template>
  <div class="zones-announcement t-text" data-qe-id="zones-announcement">
    <div class="text" v-html="md($t(`announcements.announcement.${announcementId}`))"></div>
  </div>
</template>

<script setup lang="ts">
// Info announcement section on top of the zone selection page
import { marked } from 'marked'
defineProps<{ announcementId: string }>()

function md(text: string) {
  return marked(text)
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import '~@npm/@gd/common-styles/lib/color-vars';
@import '../styles/vars';
@import '~@npm/@gd/common-styles/dist/card';
.zones-announcement {
  .card(@c9-h);
  display: flex;
  align-items: center;
  margin: 6em auto 0 5em;
  padding: @biggerspacing @biggerspacing @biggerspacing 0;
  padding-left: 7em;
  &::v-deep {
    h2 {
      margin-top: 0;
    }
    p:last-of-type {
      margin-bottom: 0;
    }
  }
  &::before {
    content: ' ';
    display: block;
    width: 13em;
    height: 16em;
    position: absolute;
    left: -6em;
    background: url(../assets/logo_announcement.png) no-repeat;
    background-size: contain;
  }
  @media screen and (max-width: 800px) {
    padding: @smallerspacing @smallerspacing @smallerspacing 0;
    padding-left: 6em;
    margin-left: 3.5em;
    &::before {
      width: 10em;
      height: 12em;
      left: -4em;
    }
  }
}
</style>
